import React, { Component } from "react";
import Select, { components } from "react-select";
import Button from "@mui/material/Button";
import FormControl from "@mui/material/FormControl";
import Grid from "@mui/material/Grid";
import MenuItem from "@mui/material/MenuItem";
import { default as SelectMui } from "@mui/material/Select";
import TextField from "@mui/material/TextField";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import { ContentState, convertToRaw, Editor, EditorState } from "draft-js";
import htmlToDraft from "html-to-draftjs";
import debounce from "lodash/debounce";
import { withSnackbar } from "notistack";
import { connect } from "react-redux";
import { IoMdArrowRoundBack } from "react-icons/io";
import CreatableSelect from "react-select/creatable";
import {
  postAPIDraft,
  postAPIMessage,
  postAPIMessageBody,
  postAPIMessages,
  postAPIMessageSubjectCategory,
  postUserSettingsGlobalSidebar,
  postUserSettingsLocal
} from "./../redux/actions";
import PopupAlert from "./PopupAlert";
import SimpleBackdrop from "./SimpleBackdrop";
import YesNoDialog from "./YesNoDialog";
// import GetAttachmentBlobFiles from "./../services/GetAttachmentBlobFile";

// 25mb
const maxFileSize = 25 * 1048576;

const DropdownIndicator = ({ innerRef, innerProps }) => "";
const SelectContainer = ({ children, ...props }) => {
  return (
    <components.SelectContainer style={{ border: "0" }} {...props}>
      {children}
    </components.SelectContainer>
  );
};
class ComposeContent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      files: [],
      open: false,
      editorState: EditorState.createEmpty(),
      popupAlertOpen: false,
      popupAlertMessage: "",
      popupAlertIsSuccessMessage: false,
      circularProgressOpen: false,
      yesNoDialogOpen: false,
      yesNoDialogContent: "",
      yesNoDialogTitle: "",
      draftEditID: null,
      isCurrentlyEditing: false,
      draftSet: true,
      emailSend: false,
      dialog: false,
      employeeToOptions: null,
      email: this.props.getAPIMailbox
    };

    this.apiClass = props.apiClass;
    this.setEditor = (editor) => {
      this.editor = editor;
    };
    this.focusEditor = () => {
      if (this.editor) {
        this.editor.focus();
      }
    };
  }

  componentDidMount() {
    this.userTypeCheck();
    if (this.props.getAPIMessage == null) {
      this.props.postAPIMessage({ toAddresses: [], body: "", subject: "" });
    }
    if (this.props.getAPIMessage !== null) {
      this.setState({ files: this.props.getAPIMessage.attachments });
    }
    this.setState({
      editorState: EditorState.createWithContent(
        ContentState.createFromBlockArray(
          htmlToDraft(
            this.props.getAPIMessage ? this.props.getAPIMessage.body : ""
          )
        )
      )
    });
  }

  saveEmailAsDraft() {
    if (!this.props.getAPIMessage) return;
    let msg = this.props.getAPIMessage;
    let CurrentDrafts = Object.assign(
      [],
      this.props.getUserSettingsLocalDrafts
    );

    if (this.state.draftEditID !== null) {
      CurrentDrafts[this.state.draftEditID] = this.props.getAPIMessage;
      this.updateDraft(CurrentDrafts);
    } else if (
      msg &&
      (msg.body !== "" ||
        (msg.toAddresses && msg.toAddresses.length > 0) ||
        msg.subject !== "")
    ) {
      CurrentDrafts.push(this.props.getAPIMessage);
      this.updateDraft(CurrentDrafts);
    }
  }

  GetUserSettingsLocal = async () => {
    return await this.apiClass
      .GetUserSettings()
      .then((res) => this.props.postUserSettingsLocal(res.local.customData));
  };

  updateDraft = async (Drafts) => {
    let DraftsObj = { Drafts };
    return await this.apiClass
      .PostUserSettings(process.env.REACT_APP_ID, DraftsObj)
      .then(() => this.GetUserSettingsLocal());
  };

  componentWillUnmount() {
    if (!this.state.emailSend) {
      this.saveEmailAsDraft();
      this.props.postAPIMessage(null);
    }
  }
  setErrorMessage = (message, continuation) => {
    this.setState(
      {
        circularProgressOpen: false,
        popupAlertMessage: message,
        popupAlertOpen: true
      },
      continuation
    );
  };

  setSuccessMessage = (message, continuation) => {
    this.setState(
      {
        circularProgressOpen: false,
        popupAlertMessage: message,
        popupAlertOpen: true,
        popupAlertIsSuccessMessage: true
      },
      continuation
    );
  };
  resetBody() {
    this.props.postAPIMessageBody("");
    this.setState({
      editorState: EditorState.createWithContent(
        ContentState.createFromBlockArray(htmlToDraft(""))
      )
    });
  }
  userTypeCheck() {
    // if user is not employee
    if (
      (this.props.getAPIEmployee === false) &
      (!this.props.getAPIMessage?.subject?.includes("Reply") & // if reply
        !this.props.history.location.pathname.includes("draft")) // if draft
    ) {
      this.props.history.push("contactus");
      return;
    }
  }
  componentDidUpdate() {
    this.userTypeCheck();
    let drafts = window.location.pathname.split("/");
    let draftID = parseInt(drafts[drafts.length - 1]);
    if (this.state.isCurrentlyEditing === false) {
      if (drafts[drafts.length - 2] === "draft") {
        this.setState({ isCurrentlyEditing: true, draftEditID: draftID });
      }
    }
    if (
      this.props.getUserSettingsLocalDrafts[draftID] !== undefined &&
      this.state.draftSet &&
      drafts[drafts.length - 2] === "draft"
    ) {
      this.props.postAPIDraft(this.props.getUserSettingsLocalDrafts[draftID]);
      this.setState({
        draftSet: false,
        editorState: EditorState.createWithContent(
          ContentState.createFromBlockArray(
            htmlToDraft(this.props.getUserSettingsLocalDrafts[draftID].body)
          )
        )
      });
    }
  }
  formBuilder = () => {
    let Body = this.props.getAPIMessage.body;
    let Subject = this.props.getAPIMessage.subject;
    let ToAddresses = this.props.getAPIMessage.toAddresses;
    let ForwardedMessageId = this.props.getAPIMessage.messageID;
    let Attachments = this.state.files;
    let Mailbox = this.props.getAPIMailbox;
    var form = new FormData();
    form.append("Body", Body);
    form.append("From", Mailbox);
    form.append("Subject", Subject);

    if (ToAddresses) {
      for (let i = 0; i < ToAddresses.length; i++) {
        form.append("ToAddresses", ToAddresses[i]);
      }
    }
    if (ForwardedMessageId) {
      form.append("ForwardedMessageId", ForwardedMessageId);
    }

    if (Attachments) {
      for (let i = 0; i < Attachments.length; i++) {
        form.append("AttachmentFiles", Attachments[i]);
        // attachment.name = attachment.name.replace(/[^0-9a-zA-Z_\s]/g, "");
      }
    }
    let domain = window.location.host;
    if (domain.search("localhost") >= 0) domain = "devnexus.admis.com";
    form.append("Domain", domain);
    form.append("AssignTo", this.props.getAPIMessage.assignTo || "");
    return form;
  };
  sendEmailConfirmed = () => {
    return this.setState(
      { emailSend: true, modalBoxState: false, circularProgressOpen: true },
      async () => {
        return await this.apiClass
          .PostMessage(this.formBuilder())
          .then((res) => {
            if (res) {
              let continuation = () => {
                this.props.updateMessages();
                this.props.history.push(
                  "/" + this.props.getAPIMailbox + "/inbox"
                );
              };
              const txt =
                "Message has been sent successfully and an ADMIS employee will be in touch with you soon";
              this.setSuccessMessage(txt, continuation);
            } else {
              this.setState({
                circularProgressOpen: false
              });
            }
          });
      }
    );
  };

  validateEmails(emails) {
    for (let i = 0; i < emails.length; i++) {
      let email = "";
      if (emails[i].indexOf("(") > -1) {
        email = emails[i].substring(
          emails[i].indexOf("(") + 1,
          emails[i].indexOf(")")
        );
      } else {
        email = emails[i];
      }
      if (!this.validateEmail(email)) {
        this.setErrorMessage(
          `${email} is not a valid email address. Please, enter a valid email address`
        );
        return false;
      }
    }
    return true;
  }

  sendMessage() {
    if (this.props.getAPIMessage.toAddresses.length === 0) {
      this.setErrorMessage("You have not entered any addresses");
      return;
    }
    if (!this.validateEmails(this.props.getAPIMessage.toAddresses)) {
      this.setErrorMessage("Invalid email destination(s)");
      return;
    }

    if (this.props.getAPIMessage.subject === "") {
      this.inputRef.focus();
      this.setErrorMessage("Please enter a subject");
      return;
    }
    if (
      this.props.getAPIMessage.body === "" ||
      this.props.getAPIMessage.body === "\n"
    ) {
      this.setState({
        yesNoDialogOpen: true,
        yesNoDialogContent: "Do you want to send this message without a body?",
        yesNoDialogTitle: "Send Message"
      });
      this.focusEditor();
      return;
    }

    this.sendEmailConfirmed();
  }
  validateEmail(email) {
    var re =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }

  Input = (props) => {
    return <components.Input {...props} />;
  };

  Menu = (props) => {
    return this.props.getAPIEmployee ? (
      <components.Menu {...props} />
    ) : (
      DropdownIndicator
    );
  };

  ListUpdate = debounce(async (letters) => {
    if (this.props.getAPIEmployee && letters?.length > 0) {
      let emailList = await this.apiClass.GetEmailList(letters);
      if (emailList?.length > 0) {
        let employeeToOptions = emailList.map((i) => {
          let fName =
            i.firstName.length > 1
              ? i.firstName[0].toUpperCase() +
                i.firstName.substring(1, i.firstName.length).toLowerCase()
              : "";
          let lName =
            i.lastName.length > 1
              ? i.lastName[0].toUpperCase() +
                i.lastName.substring(1, i.lastName.length).toLowerCase()
              : "";
          let label = `${fName} ${lName} (${i.userName?.toLowerCase()})`;
          return {
            label: label,
            value: i.userName
          };
        });
        this.setState({
          employeeToOptions
        });
      }
    }
  }, 500);

  Option = (props) => {
    return (
      <div className="options">
        <components.Option {...props} />
      </div>
    );
  };

  getContent() {
    return (
      <>
        <p>Please type your message:</p>
        <div
          style={{
            border: "1px solid gray",
            borderRadius: "5px",
            minHeight: "6em",
            height: "calc(100vh - 350px)",
            overflow: "auto",
            padding: "5px"
          }}
          onClick={this.focusEditor}
        >
          <Editor
            ref={this.setEditor}
            editorState={this.state.editorState}
            onChange={(editorState) => {
              const blocks = convertToRaw(
                editorState.getCurrentContent()
              ).blocks;
              const text = blocks
                .map((block) => (!block.text.trim() && "\n") || block.text)
                .join("\n");
              var newMessage = JSON.parse(
                JSON.stringify(this.props.getAPIMessage)
              );
              newMessage.body = text;
              this.props.postAPIMessage(newMessage);
              this.setState({ editorState });
            }}
          />
        </div>
        <input
          ref={(ref) => (this.fileUploader = ref)}
          type="file"
          id="Attachments"
          name="Attachments"
          accept=".7z,.bmp,.csv,.doc,.docx,.jpeg,.jpg,.mov,.mp3,.mp4,.mpeg,.msg,.pdf,.png,.ppt,.pptx,.rar,.txt,.wav,.wmv,.xls,.xlsx,.zip"
          multiple
          style={{ display: "none" }}
          onChange={(action) => {
            var files = this.state.files.slice();
            if (action.currentTarget.files[0] !== undefined)
              files.push(action.currentTarget.files[0]);
            let filesWarn = false;
            if (files.length > 0) {
              files.map((eachFile) => {
                const regex = /[^0-9a-zA-Z._\s]/g;
                if (eachFile.name.match(regex)?.length > 0) {
                  let chars = eachFile.name.match(regex).map((i) => i);
                  this.setErrorMessage(
                    `${eachFile.name} has special characters, please remove them.(${chars})`
                  );
                  filesWarn = true;
                } else if (eachFile.size > maxFileSize) {
                  this.setErrorMessage(
                    "Your file is larger allowed limit of 25MB"
                  );
                  filesWarn = true;
                }
                return null;
              });
            }
            if (!filesWarn) {
              this.setState({ files });
            }
          }}
        ></input>
        <div style={{ display: "flex", alignItems: "center", margin: "5px 0" }}>
          <AttachFileIcon
            style={{ cursor: "pointer" }}
            onClick={() => {
              this.fileUploader.click();
            }}
          />
          <span id="maxFileSizeName">
            MAX FileSize 25MB. Name can only include letters, numbers, periods,
            underscores, and spaces.
          </span>
        </div>
        {this.state.files && this.state.files.length > 0 ? (
          <Select
            isMulti
            style={{ width: "100%" }}
            name="Attachments"
            value={this.state.files.map((x, y) => {
              return { id: y, value: x, label: x.name, type: "file" };
            })}
            className="basic-multi-select"
            classNamePrefix="select"
            onChange={(i, y) => {
              let id = y.removedValue.id;
              let files = this.state.files.filter(
                (eachItem, index) => index !== id
              );
              this.setState({ files });
            }}
            components={{
              DropdownIndicator: DropdownIndicator,
              IndicatorSeparator: DropdownIndicator,
              Menu: DropdownIndicator,
              ClearIndicator: DropdownIndicator,
              Control: SelectContainer
            }}
          />
        ) : (
          ""
        )}
        <div style={{ width: "100%" }} className="Button">
          <Button
            onClick={() => {
              this.sendMessage();
            }}
            style={{
              margin: "auto",
              padding: "2px 16px"
            }}
            variant="contained"
            className="ActionButton"
          >
            Send
          </Button>
        </div>
      </>
    );
  }
  extractEmail(email) {
    return email.substring(email.indexOf("(") + 1, email.indexOf(")"));
  }
  getFromEmails(emails) {
    emails = JSON.parse(JSON.stringify(emails));
    return (
      <>
        <Grid
          item
          xs={3}
          sm={3}
          md={3}
          lg={3}
          style={{ display: "flex", alignItems: "center" }}
        >
          <label id="selectFromLabel">
            <strong>From:</strong>{" "}
          </label>
          <FormControl id="SelectFromBox">
            <SelectMui
              id="selectFrom"
              value={this.state.email}
              // label="Select"
              onChange={(e) => this.setState({ email: e.target.value })}
            >
              {emails.map((email) => (
                <MenuItem key={email} value={email}>
                  {email}
                </MenuItem>
              ))}
            </SelectMui>
          </FormControl>
        </Grid>
      </>
    );
  }
  render() {
    let fromEmailCheck = this.props.getAPIMailboxes;
    let isMutliEmailActive = fromEmailCheck?.length > 1 ? true : false;
    return (
      <div style={{ padding: "0px 10px" }}>
        <Button
          variant="secondary"
          style={{ padding: 0, margin: 0, marginBottom: "10px" }}
          onClick={() => {
            window.history.back();
          }}
        >
          <IoMdArrowRoundBack size={25} /> Go Back
        </Button>
        <PopupAlert
          errorOpen={this.state.popupAlertOpen}
          handleErrorClose={() => {
            this.setState({ popupAlertOpen: false });
          }}
          errorMessage={this.state.popupAlertMessage}
          isSuccessMessage={this.state.popupAlertIsSuccessMessage}
        />
        <div
          className="from-to-fields"
          onKeyUp={(i) => {
            let value = i.target.value;
            if (value && value.length > 0) this.props.closeSnackbar(); // when user types remove the error
            this.setState({ employeeToOptions: [] }, () => {
              this.ListUpdate(value);
            });
          }}
        >
          {isMutliEmailActive ? this.getFromEmails(fromEmailCheck) : ""}

          <div
            style={{
              width: "100%",
              display: "flex",
              alignItems: "center",
              gap: "5px"
            }}
          >
            <label id="selectToLabel">
              <strong>To:</strong>
            </label>
            <CreatableSelect
              id="EmailList"
              noOptionsMessage={() => "Please type to get email suggestions"}
              styles={{
                // Fixes the overlapping problem of the component
                menu: (provided) => ({ ...provided, zIndex: 9998 })
              }}
              isMulti
              name="To"
              placeholder="Please type to get email suggestions"
              value={this.props.getAPIMessage?.toAddresses.map((x) => {
                return { label: x, value: x };
              })}
              formatCreateLabel={(i) => i}
              className="basic-multi-select"
              classNamePrefix="select"
              options={this.state.employeeToOptions}
              // isValidNewOption={() => false} Disallows user to enter email value
              // onKeyDown={(i) => console.log(i.target.value)}
              onBlur={(data) => {
                if (
                  data.currentTarget.value === "" ||
                  data.currentTarget.value === undefined
                )
                  return;
                var newMessage = JSON.parse(
                  JSON.stringify(this.props.getAPIMessage)
                );
                newMessage?.toAddresses.push(data.currentTarget.value);
                this.props.postAPIMessage(newMessage);
              }}
              components={{
                DropdownIndicator: DropdownIndicator,
                IndicatorSeparator: DropdownIndicator,
                Menu: this.Menu,
                Input: this.Input,
                Option: this.Option,
                ClearIndicator: DropdownIndicator
              }}
              onChange={(value) => {
                if (
                  value.length > 0 &&
                  !this.validateEmail(value[value.length - 1].value) // last email
                ) {
                  // if this is not a valid email
                  this.props.enqueueSnackbar(
                    `${value[0].value} is not a valid email address`,
                    { variant: "error" }
                  );
                } else if (value.length === 0 && !this.props.getAPIEmployee) {
                  this.props.enqueueSnackbar(
                    `You cannot remove existing email address`,
                    { variant: "error" }
                  );
                } else {
                  var newMessage = JSON.parse(
                    JSON.stringify(this.props.getAPIMessage)
                  );
                  newMessage.toAddresses = value
                    ? value.map((x) => `${x.value}`)
                    : [];
                  this.props.postAPIMessage(newMessage);
                }
              }}
            />
          </div>
        </div>
        <>
          <TextField
            inputRef={(ip) => (this.inputRef = ip)}
            style={{ width: "100%", marginBottom: "10px" }}
            variant="standard"
            label="Subject"
            value={this.props.getAPIMessage?.subject}
            onChange={(e) => {
              var newMessage = JSON.parse(
                JSON.stringify(this.props.getAPIMessage)
              );
              newMessage.subject = e.currentTarget.value;
              this.props.postAPIMessage(newMessage);
            }}
          />
          {this.getContent()}
        </>
        <SimpleBackdrop
          open={this.state.circularProgressOpen}
          onClick={this.handleCircularProgressClose}
        />
        <YesNoDialog
          open={this.state.yesNoDialogOpen}
          handleClose={(e) => {
            this.setState({ yesNoDialogOpen: false });
          }}
          handleYes={this.sendEmailConfirmed}
          content={this.state.yesNoDialogContent}
          title={this.state.yesNoDialogTitle}
          noBtnName={"Don't Send"}
          yesBtnName={"Send Anyway"}
        />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    getAPIMessage: state.API.Message,
    getAPIEmployee: state.API.Employee,
    getAPIMailbox: state.API.Mailbox,
    getAPIMailboxes: state.API.Mailboxes,
    getUserSettingsLocalDrafts: state.User.Settings.Local.Drafts
  };
}
const mapDispatchToProps = {
  postAPIMessages,
  postAPIMessage,
  postAPIDraft,
  postAPIMessageBody,
  postAPIMessageSubjectCategory,
  postUserSettingsGlobalSidebar,
  postUserSettingsLocal
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withSnackbar(ComposeContent));
